<ng-container *ngIf="stop?.type !== 'warning'">
  <td class="route-stop-icon-cell">
    <span
      class="route-stop-line"
      *ngIf="stop.numStops > 0"
      [ngClass]="{
        top: stop.numStops > 1 && stopIndex === 0,
        bottom: stopIndex === stop.numStops - 1 && stopIndex !== 0,
        middle: stopIndex !== 0 && stopIndex !== stop.numStops - 1
      }"
    ></span>
    <app-stop-icon
      [stopType]="stop.stopType"
      [routeColor]="stop.routeColor"
      [stopNumber]="stopIndex"
    ></app-stop-icon>
  </td>
  <td class="route-stop-address" id="copy-table_{{ stopIndex }}">
    <div *ngIf="stop.name" class="font-weight-bolder">
      {{ stop.name }}
    </div>
    <div
      *ngIf="
        stop.lngLat &&
        !(
          stop?.address?.streetAddress ||
          stop.address.city ||
          stop.address.state ||
          stop.address.zip
        )
      "
    >
      Lon: {{ stop.lngLat[0] }}, Lat: {{ stop.lngLat[1] }}
    </div>
    <div *ngIf="stop.address.streetAddress" class="font-weight-bolder">
      {{ stop.address.streetAddress }}
    </div>
    <div>
      <span *ngIf="stop.address.city">{{ stop.address.city }}</span>
      <span *ngIf="stop.address.state">, {{ stop.address.state }}</span>
      <span *ngIf="stop.address.zip"> {{ stop.address.zip }}</span>
      <span class="text-gray-4" *ngIf="stop.address.county">
        ({{ stop.address.county }} county)</span
      >
    </div>
  </td>

  <ng-container
    *ngIf="stop?.editMode === routeEditModeEnum.AddStop; else editOptions"
  >
    <td *ngIf="isTollsAvailable" class="route-stop-detail-cell">
      {{ stop?.tolls | displayCurrency : displayCurrency }}&#32;
    </td>
    <td *ngIf="!isTollsAvailable" class="route-stop-detail-cell">&#32;</td>
    <td class="route-stop-detail-cell">
      {{ stop?.miles | precision : precision }}
    </td>
    <td class="route-stop-detail-cell">
      {{ stop | stopHoursMinusDuration }}
      <div *ngIf="stop.stopTime">({{ stop?.stopTime | stopDuration }})</div>
    </td>
    <td class="route-stop-detail-cell" *ngIf="stop?.etaEtd">
      {{ stopIndex === 0 ? "Dep" : "Arr" }}&#32;&#32;{{ stop.etaEtd.date }}
      <br />
      {{ stop?.etaEtd?.time }}
    </td>
    <td class="route-stop-action">
      <div
        *ngIf="{ loc: location$ | async } as l"
        class="btn-group position-relative"
        dropdown
      >
        <button
          (click)="setFavouriteLocation()"
          class="btn btn-icon-only"
          tooltip="More Actions"
          container="body"
          [adaptivePosition]="false"
          dropdownToggle
        >
          <i class="modus-icons material-icons">more_vertical</i>
        </button>
        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
          <li role="menuitem">
            <button
              class="dropdown-item small px-2 py-1"
              (click)="deleteStop()"
            >
              <span>Delete</span>
            </button>
          </li>
          <li role="menuitem">
            <button
              class="dropdown-item small px-2 py-1"
              *ngIf="!l.loc?.isFavorite"
              (click)="saveFavorite(l.loc)"
            >
              <span>Save as Favorite</span>
            </button>
            <button
              class="dropdown-item small px-2 py-1"
              *ngIf="l.loc?.isFavorite"
              (click)="removeFavorite(l.loc)"
            >
              <span>Remove from Favorites</span>
            </button>
          </li>
          <li role="menuitem">
            <button class="dropdown-item small px-2 py-1" (click)="showOnMap()">
              <span>Show on Map</span>
            </button>
          </li>
          <li role="menuitem">
            <button
              class="dropdown-item small px-2 py-1"
              (click)="copyToClipboard()"
            >
              <span>Copy Address</span>
            </button>
          </li>
        </ul>
      </div>
    </td>
  </ng-container>
  <ng-template #editOptions>
    <td colspan="5" *ngIf="stopTimeLabel">
      <div class="form-group mr-2">
        <label for="stopDuration-{{ stopIndex }}">{{ stopTimeLabel }}</label>
        <input
          id="stopDuration-{{ stopIndex }}"
          class="form-control"
          type="text"
          maxlength="5"
          placeholder="hh:mm, hh.hh or mm"
          [formControl]="stop.formControl"
          [ngClass]="{ 'is-invalid': stop?.formControl?.invalid }"
        />
        <span *ngIf="stop?.formControl?.invalid" class="text-danger small"
          >Format should be hh:mm, hh.hh or mm</span
        >
      </div>
    </td>
  </ng-template>
</ng-container>

<td colspan="9" *ngIf="stop.type === 'warning'">
  <span
    class="message message-danger"
    style="font-size: small; display: block; margin-bottom: 0px"
  >
    <i class="modus-icons" style="font-size: small">info</i>{{ stop?.value }}
    <br />
    <a href="#" (click)="openReport()" style="display: contents"
      >View the report for more info.</a
    >
  </span>
</td>
